<template>
    <div 
        :class="{ 
            'ui-switch-toggler': true, 
            'disabled': disabled, 
            'active': active, 
        }"
        :disabled="disabled"
    >
        <input 
            type="checkbox" 
            :id="`switcher-${idStatic}`" 
            v-model="active"
            @input="setActive(!active)"
        >
        <button
            :type="'button'"
            :title="labelText"
            :class="{ 'ui-switch-toggler__switch': true }"
            @click="setActive(!active)" 
        ><span></span></button>
        <label 
            v-if="labelText" 
            v-html="labelText"
            :for="`switcher-${idStatic}`" 
            @click.prevent="setActive(!active)" 
        ></label>
    </div>
</template>

<script>
import VueTypes, { nullable } from 'vue-types'
import staticId from '~/mixins/static-id'

export default {
    name: 'MySwitchToggler',
    mixins: [staticId],
    props: {
        labelText: VueTypes.oneOfType([String, nullable]).def(null),
        active: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
    },
    methods: {
        setActive(flag) {
            this.$emit('input', flag)
        },
    }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>